import React, { useEffect, useState, useCallback, useRef } from 'react';
import { Dropdown, InputGroup, Col, Form } from 'react-bootstrap';
import { FieldSelectGroup } from './fs-cpgroup';
import { FieldSelectSubGroup } from './fs-cpsubgroup';
import { FieldSelectSubSubGroup } from './fs-cpsubsubgroup';
import { Button } from 'react-bootstrap';
import { useFormikContext } from 'formik';
import { gql, useApolloClient } from '@apollo/client';
import { ApolloClient } from '@apollo/client';
import { useWhyDidYouUpdate } from 'motion-components';
import i18next from 'i18next';

export async function getCpGroupName(client: ApolloClient<object>, id: number) {
  const ret = await client.query({
    query: gql`
      query getCpGroupById($id: Int) {
        getCpGroupById(id: $id) {
          id
          name
        }
      }
    `,
    variables: {
      id: id,
    },
    fetchPolicy: 'network-only',
  });
  return ret?.data?.getCpGroupById?.name ?? '';
}

export async function getCpSubgroupName(client: ApolloClient<object>, id: number) {
  const ret = await client.query({
    query: gql`
      query getCpSubgroupById($id: Int) {
        getCpSubgroupById(id: $id) {
          id
          name
        }
      }
    `,
    variables: {
      id: id,
    },
    fetchPolicy: 'network-only',
  });
  return ret?.data?.getCpSubgroupById?.name ?? '';
}

export async function getCpSubsubgroupName(client: ApolloClient<object>, id: number) {
  const ret = await client.query({
    query: gql`
      query getCpSubsubgroupById($id: Int) {
        getCpSubsubgroupById(id: $id) {
          id
          name
        }
      }
    `,
    variables: {
      id: id,
    },
    fetchPolicy: 'network-only',
  });
  return ret?.data?.getCpSubsubgroupById?.name ?? '';
}

async function fetchCategoryText(client: ApolloClient<object>, values): Promise<string> {
  let text = '';
  if (values.groupId) text = await getCpGroupName(client, values.groupId);
  if (values.subgroupId) text += ' -> ' + (await getCpSubgroupName(client, values.subgroupId));
  if (values.subsubgroupId)
    text += ' -> ' + (await getCpSubsubgroupName(client, values.subsubgroupId));
  return text;
}

type Props = {
  data?: any;
  values?: any;
  setFieldValue?: any;
  setFieldTouched?: any;
  reset?: boolean;
  setReset?: () => void;
  disabled?: boolean;
  search?: boolean;
  as?: any;
  initialText?: string;
  setInitialText?: any;
};

const FsCategoryGroup = ({
  data,
  values,
  setFieldValue,
  setFieldTouched,
  reset,
  setReset,
  disabled,
  search = false,
  as,
  initialText,
  setInitialText,
}: Props) => {
  //-------------------- Body -------------------------------------------
  //
  const isFirstRun = useRef(true);
  const formikContext = useFormikContext<any>();
  const client = useApolloClient();

  async function fetchText() {
    const text = await fetchCategoryText(client, formikContext.values);
    if (typeof setInitialText === 'function') {
      setInitialText(text);
    }
  }

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;

      //setInitialText('init');
      // console.log('FsCategoryGroup ***************', formikContext.values);
    }
    fetchText();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);

  //-------------------- Handlers -------------------------------------------
  //

  //
  //-------------------- Render ----------------------------------------------
  //
  const [show, setShow] = useState(false);

  return (
    <Col as={as}>
      <Form.Label>{i18next.t('Κατηγορία Δραστηριότητας')} :</Form.Label>
      <InputGroup>
        <Form.Control
          type="text"
          aria-describedby="inputGroupPrepend"
          name="cpGroup.name"
          disabled
          // value={
          //   values
          //     ? values?.cpGroup === null
          //       ? ''
          //       : values?.cpGroup?.name
          //     : initialText
          //     ? initialText
          //     : ''
          // }
          value={initialText}
          // onChange={}
          // isInvalid={}
        />
        <Dropdown show={show}>
          <Dropdown.Toggle
            disabled={disabled}
            onClick={() => {
              console.log('fs-categorygroup-Dropdown-clicked');
              setShow(!show);
              /* setReset(false); */
            }}
            variant="outline-secondary"
            id="dropdown-basic"
            style={{
              border: '1px solid #ced4da',
              borderTopLeftRadius: '0',
              borderBottomLeftRadius: '0',
            }}
          ></Dropdown.Toggle>

          <Dropdown.Menu align="end" style={{ width: '30em' }}>
            <CategoriesSelectionPage
              fetchText={fetchText}
              setShow={setShow}
              show={show}
              data={data}
              values={values}
              setFieldValue={setFieldValue}
              setFieldTouched={setFieldTouched}
              reset={reset}
              setReset={setReset}
              search={search}
            />
          </Dropdown.Menu>
        </Dropdown>
      </InputGroup>
    </Col>
  );
};

const CategoriesSelectionPage = ({
  fetchText,
  data,
  values,
  setFieldValue,
  setFieldTouched,
  setShow,
  show,
  reset,
  setReset,
  search,
}) => {
  const isFirstRun = useRef(true);
  const isFirstRun2 = useRef(true);
  const [groupId] = useState(values?.groupId ?? null);
  const [subGroupId] = useState(values?.subgroupId ?? null);
  const [subSubGroupId] = useState(values?.subsubgroupId ?? null);
  const [groupName, setGroupName] = useState(values?.cpGroup?.name ?? null);
  const [subGroupName, setSubGroupName] = useState(values?.cpSubgroup?.name ?? null);
  const [subSubGroupName, setSubSubGroupName] = useState(values?.cpSubsubgroup?.name ?? null);

  const { values: searchValues, setFieldValue: setSearchValues } = useFormikContext<any>();
  useWhyDidYouUpdate('[CategoriesSelectionPage]', {
    reset,
    values,
    isFirstRun,
    isFirstRun2,
    searchValues,
  });

  const HandleOk = () => {
    if (!search) {
      if (values?.groupId !== groupId) {
        setFieldValue('cpGroup.name', groupName);
      }
      if (values?.subgroupId !== subGroupId) {
        setFieldValue('cpSubgroup.name', subGroupName);
      }
      if (values?.subsubgroupId !== subSubGroupId) {
        setFieldValue('cpSubsubgroup.name', subSubGroupName);
      }
    } else {
      if (groupName !== null) {
        fetchText();
      }
    }

    setShow(!show);
  };

  // useEffect if the user refreshes the form values
  useEffect(() => {
    if (reset === true) {
      isFirstRun.current = true;
      isFirstRun2.current = true;
      setReset(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reset]);

  const setFieldValueAndTouched = useCallback(
    async (name, touched: boolean) => {
      //await Promise.all([setFieldValue(name, _value, true), setFieldTouched(name, touched)]);
      await setFieldValue(name, null, true); //field,value,shouldValidate
      await setFieldTouched(name, touched); //field,touched,shouldValidate
    },
    [setFieldTouched, setFieldValue],
  );

  /*  useEffect(() => {
    setReset(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSubmitting]); */

  // useEffect to clean subgroup if group changes
  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    } else {
      console.log('hi2');
      if (search) {
        setSearchValues('subgroupId', false);
      } else {
        setFieldValueAndTouched('subgroupId', false);
      }
    }
    /* } */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values?.groupId, searchValues?.groupId]);

  // useEffect to clean subsubgroup if subgroup changes
  useEffect(() => {
    if (isFirstRun2.current) {
      isFirstRun2.current = false;
      return;
    } else {
      if (search) {
        setSearchValues('subsubgroupId', false);
      } else {
        setFieldValueAndTouched('subsubgroupId', false);
      }
    }
    /* } */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values?.subgroupId, searchValues?.subgroupId]);

  return (
    <div className="container">
      <FieldSelectGroup
        onChange={(e) => setGroupName(e.label)}
        defaultValues={data}
      ></FieldSelectGroup>
      <br></br>
      <FieldSelectSubGroup
        onChange={(e) => setSubGroupName(e.label)}
        //disabled={!values?.groupId ?? search ? !searchValues.groupId : undefined}
        disabled={!values?.groupId ? !searchValues.groupId : undefined}
        groupId={values?.groupId ?? search ? searchValues.groupId : undefined}
        defaultValues={data}
      ></FieldSelectSubGroup>
      <br></br>
      <FieldSelectSubSubGroup
        onChange={(e) => setSubSubGroupName(e.label)}
        disabled={
          (!values?.subgroupId || !values?.groupId) ?? search
            ? !searchValues.groupId || !searchValues.subgroupId
            : undefined
        }
        groupId={values?.subgroupId ?? search ? searchValues.subgroupId : undefined}
        defaultValues={data}
      ></FieldSelectSubSubGroup>
      <Button onClick={() => HandleOk()} style={{ width: '70px' }} variant="primary" type="button">
        {' ΟΚ '}
      </Button>
    </div>
  );
};

export default FsCategoryGroup;
FsCategoryGroup.whyDidYouRender = true;
